import { apiFetcher } from "../services/API.service";

export async function getSignedUrls(
  section: string,
  fileTypeF: string,
  fileTypeT?: string
): Promise<
  | {
      type: "fullOnly";
      signedURLF: string;
      keyF: string;
    }
  | {
      type: "both";
      signedURLF: string;
      keyF: string;
      signedURLT: string;
      keyT: string;
    }
  | false
> {
  console.log("HIT getSignedUrls");
  console.log(section, fileTypeF, fileTypeT);
  try {
    const response = await apiFetcher({
      route: "/image/upload",
      method: "POST",
      options: {
        body: {
          fullOrThumb: {
            full: fileTypeF,
            thumb: fileTypeT
          },
          section: section
        }
      }
    });

    console.log(response);

    if (response.status === 200 || response.status === 202) {
      let signedURLF, keyF, signedURLT, keyT;

      // Check if response.data is an array
      if (Array.isArray(response.data)) {
        // Iterate over each item in the response.data array
        response.data.forEach((item) => {
          // Check for fileTypeF and validate its structure
          if (
            item.fileType === "full" &&
            item.s3 &&
            typeof item.s3.signedURL === "string" &&
            typeof item.s3.key === "string"
          ) {
            signedURLF = item.s3.signedURL;
            keyF = item.s3.key;
          }

          // Check for fileTypeT and validate its structure
          if (
            item.fileType === "thumb" &&
            item.s3 &&
            typeof item.s3.signedURL === "string" &&
            typeof item.s3.key === "string"
          ) {
            signedURLT = item.s3.signedURL;
            keyT = item.s3.key;
          }
        });

        // Determine the response type based on the presence of fileTypeF and fileTypeT data
        if (signedURLF && keyF && signedURLT && keyT) {
          return {
            type: "both",
            signedURLF,
            keyF,
            signedURLT,
            keyT
          };
        } else if (signedURLF && keyF) {
          return {
            type: "fullOnly",
            signedURLF,
            keyF
          };
        }
      }

      // Return false if none of the conditions are met
      return false;
    }

    return false;
  } catch (error) {
    console.error("An error occurred while creating image:", error);
    return false;
  }
}

export async function sendToS3(
  image: {
    full: string;
    thumb?: string;
  },
  fileTypeF: string,
  fileTypeT: string | undefined,
  signedURLResponse:
    | {
        type: "fullOnly";
        signedURLF: string;
        keyF: string;
      }
    | {
        type: "both";
        signedURLF: string;
        keyF: string;
        signedURLT: string;
        keyT: string;
      }
): Promise<boolean> {
  try {
    if (signedURLResponse.type === "fullOnly") {
      // convert message.image.full from base64 to Blob
      const blobImage = await fetch(image.full).then((res) => res.blob());
      console.log(blobImage);

      const response = await fetch(signedURLResponse.signedURLF, {
        method: "PUT",
        body: blobImage,
        headers: {
          "Content-Type": blobImage.type
        }
      });

      console.log(response);

      if (response.status !== 200) {
        return false;
      }
    }

    if (signedURLResponse.type === "both") {
      console.log("Uploading both images");
      //   const blobImage: Blob = await fetch(image.full).then((res) => res.blob());
      const arrayBuffImage: ArrayBuffer = await fetch(image.full).then((res) =>
        res.arrayBuffer()
      );
      //   console.log(blobImage);
      console.log(signedURLResponse.signedURLF);
      console.log(fileTypeF);

      const responseF = await fetch(signedURLResponse.signedURLF, {
        method: "PUT",
        body: arrayBuffImage,
        headers: {
          "Content-Type": `image/${fileTypeF}`
        }
      });

      console.log(responseF);

      if (responseF.status !== 200) {
        return false;
      }

      const blobImage2 = await fetch(image.thumb as string).then((res) =>
        res.blob()
      );

      const responseT = await fetch(signedURLResponse.signedURLT, {
        method: "PUT",
        body: blobImage2,
        // body: message.image.full,
        headers: {
          "Content-Type": `image/${fileTypeT}`
        }
      });

      console.log(responseT);

      if (responseT.status !== 200) {
        return false;
      }
    }
    return true;
  } catch (error) {
    console.log("An error occurred while uploading to DigitalOcean");
    console.log(error);
    return false;
  }
}
